module.exports = __webpack_public_path__ + "img/AT0000002672879.bfbc77dd.png";